import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-wild-sand py-70 px-15 sm:py-80 sm:px-35 md:py-150 md:px-30" }

import ProductImage from '@/shared/media/ProductImage.vue';
import { ProductSpotModel } from '@/types/productServerApi';
import { computed } from 'vue';
import useProductAngleImage from '@/shared/product/details/useProductAngleImage';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpotImage',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
    product: ProductSpotModel;
}

const { getMaybeAngleImageSku } = useProductAngleImage();



const productImageSku = computed(() => {
    return getMaybeAngleImageSku(props.product.sku, props.product.imageProperties);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProductImage, {
      sku: _unref(productImageSku),
      "aspect-ratio": 7/3,
      "width-on-screen": {
                'xs': 50,
                'sm': 25,
            },
      "cache-bust": __props.product.imageProperties.version
    }, null, 8, ["sku", "cache-bust"])
  ]))
}
}

})